import { useEffect, useRef, useState } from "react";

export const useLoginForm = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isLoginDisabled, setIsLoginDisabled] = useState(false);
  const passwordRef = useRef<HTMLInputElement | null>(null);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleUsernameKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      passwordRef.current?.focus();
    }
  };

  useEffect(() => {
    if (userName && password) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [userName, password]);

  useEffect(() => {
    setIsLoginDisabled(false);
  }, [userName, password]);

  return {
    userName,
    setUserName,
    password,
    setPassword,
    showPassword,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleUsernameKeyPress,
    passwordRef,
    visible,
    isLoginDisabled,
    setIsLoginDisabled,
  };
};
